import { createHash } from 'crypto';

export const ROOM_META_PASSWORD_HASH_KEY = 'password_hash';

export type RoomAccessMetadata = {
  passwordHash?: string;
};

export function hashRoomPassword(password: string): string {
  return createHash('sha256').update(password, 'utf8').digest('hex');
}

export function parseRoomAccessMetadata(metadata: string | undefined): RoomAccessMetadata {
  if (!metadata?.trim()) {
    return {};
  }
  try {
    const parsed = JSON.parse(metadata) as Record<string, unknown>;
    const passwordHash = parsed[ROOM_META_PASSWORD_HASH_KEY];
    if (typeof passwordHash === 'string' && passwordHash.length > 0) {
      return { passwordHash };
    }
  } catch {
    // Legacy or non-JSON metadata — treat as open room.
  }
  return {};
}

export function buildRoomAccessMetadata(password: string): string {
  return JSON.stringify({
    [ROOM_META_PASSWORD_HASH_KEY]: hashRoomPassword(password),
  });
}

export function verifyRoomPassword(password: string, expectedHash: string): boolean {
  return hashRoomPassword(password) === expectedHash;
}

export const ROOM_PASSWORD_SESSION_PREFIX = 'lk-room-pw-';

export function roomPasswordSessionKey(roomName: string): string {
  return `${ROOM_PASSWORD_SESSION_PREFIX}${roomName}`;
}
